function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m405.328 153.611.001 334.494h106.671l-.001-334.494zm38.032 61.57h30v30h-30zm30 165.421h-30v-30h30zm.415-67.711h-30v-30h30z",
    fill: "#4b5563",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.549 75.514h106.451v48.098h-106.451z",
    fill: "#4b5563",
    "data-original": "#000000",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    d: "m.002 47.46-.002 440.642 107.168-.002.002-410.156zm38.552 100.101h30v30h-30zm30.031 233.131h-30v-30h30zm0-67.71h-30v-30h30zm.191-67.711h-30v-30h30z",
    fill: "#4b5563",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m211 405.605h30v82.5h-30z",
    fill: "#4b5563",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271 405.605h30v82.5h-30z",
    fill: "#4b5563",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.97 23.895v464.21h41.03v-112.5h150v112.5h44.3v-464.21zm71.03 306.71h-30v-63.75h30zm0-93.75h-30v-63.75h30zm0-93.75h-30v-63.75h30zm60 187.5h-30v-63.75h30zm0-93.75h-30v-63.75h30zm0-93.75h-30v-63.75h30zm60 187.5h-30v-63.75h30zm0-93.75h-30v-63.75h30zm0-93.75h-30v-63.75h30z",
    fill: "#4b5563",
    "data-original": "#000000",
    style: {},
    className: ""
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.5829fdef.svg";
export { ForwardRef as ReactComponent };